<template>
  <v-form lazy-validation v-model="valid" ref="form">
    <v-row>
      <v-col cols="12" md="9">
        <v-card class="d-flex flex-column white rounded pa-9 d-flex items-center justify-start"
                :loading="loading">
          <v-row align="center" justify="space-between">
            <v-col cols="12" md="10" class="d-flex align-items-start">
              <v-card-title class="secondary--text font-weight-bold">
                {{$t('directive_admins.directive_information')}}
              </v-card-title>
            </v-col>
            <v-col cols="12" md="2" class="d-flex align-items-start justify-content-end">
                <v-btn fab small color="deep-purple lighten-1" class="ml-auto" dark
                       :disabled="loading"
                       @click="update()">
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>
                <v-btn
                  fab
                  small
                  color="indigo lighten-1"
                  class="ml-2"
                  dark
                  :disabled="loading || !adminToSave.dni"
                   :title="$t('directive_admins.impersonate')"
                  @click="openImpersonateModal()"
                >
                  <v-icon>mdi-account-switch</v-icon>
                </v-btn>
            </v-col>
          </v-row>
          <v-col cols="12">
            <v-row align="center" justify="center" class="mb-1">
              <v-col>
                <span>ID: </span>
                <span class="deep-purple--text font-weight-bold">{{directiveAdminId}}</span>
              </v-col>
              <v-col>
                <span>{{$t('directive_admins.creation_date')}}: </span>
                <span class="deep-purple--text font-weight-bold">
                  {{created |  moment('MM/D/YYYY')}}
                </span>
              </v-col>
              <v-col>
                <span>{{$t('directive_admins.last_access')}}: </span>
                <span class="deep-purple--text font-weight-bold d-block">
                  {{lastAccessDate || $t('directive_admins.without_last_access')}}
                </span>
              </v-col>
            </v-row>
            <v-divider/>
          </v-col>

          <!-- Editable data -->
          <!-- Personal information -->
          <v-row align="center" justify="center">
            <v-col cols="12" md="5">

              <v-row align="start" justify="start" class="d-flex flex-column">
                <span class="body black--text my-1">{{$t('directive_admins.dni')}}</span>
                <v-text-field
                  filled
                  flat
                  dense
                  :placeholder="$t('directive_admins.dni')"
                  :rules="dniRule"
                  v-model="adminToSave.dni"
                />
              </v-row>
              <v-row align="start" justify="start" class="d-flex flex-column">
                <span class="body black--text my-1">{{$t('directive_admins.firstname')}}</span>
                <v-text-field
                  filled
                  flat
                  dense
                  :placeholder="$t('directive_admins.firstname')"
                  :rules="requiredRule('firstname')"
                  v-model="adminToSave.firstname"
                />
              </v-row>
              <v-row align="start" justify="start" class="d-flex flex-column">
                <span
                  class="body black--text my-1">{{$t('directive_admins.lastname')}}</span>
                <v-text-field
                  dense
                  :placeholder="$t('directive_admins.lastname')"
                  filled
                  flat
                  v-model="adminToSave.lastname"
                  :rules="requiredRule('lastname')"
                />
              </v-row>
              <v-row align="start" justify="start" class="d-flex flex-column">
                <span
                  class="body black--text my-1">{{$t('directive_admins.lastname2nd')}}</span>
                <v-text-field
                  dense
                  :placeholder="$t('directive_admins.lastname2nd')"
                  filled
                  flat
                  v-model="adminToSave.lastname2nd"
                />
              </v-row>

              <v-row align="start" justify="start" class="d-flex flex-column">
                <span
                  class="body black--text my-1">{{$t('directive_admins.email')}}</span>
                <v-text-field
                  dense
                  :placeholder="$t('directive_admins.email')"
                  filled
                  flat
                  v-model="adminToSave.email"
                  :rules="emailRule"
                />
              </v-row>

            </v-col>
            <v-divider vertical class="mx-1"/>

            <!-- School information -->
            <v-col cols="12" md="6" class="mt-n12">
              <v-row align="center" justify="center" class="d-flex flex-column">
                <span class="black--text">{{$t('directive_admins.state')}}</span>
                <v-radio-group v-model="adminToSave.active" row>
                  <v-radio
                    :label="$t('directive_admins.active')"
                    :value="true"
                    color="deep-purple lighten-1"
                  />
                  <v-radio
                    :label="$t('directive_admins.inactive')"
                    :value="false"
                    color="deep-purple lighten-1"
                  />
                </v-radio-group>
              </v-row>
              <v-divider/>

              <v-col cols="12" class="pa-3">
                <v-row align="start" justify="center" class="d-flex flex-column">
                  <span class="body black--text my-1">
                    {{$t('directive_admins.school')}}
                  </span>
                  <v-autocomplete
                    class="w-100"
                    filled
                    flat
                    dense
                    v-model="adminToSave.school_id"
                    :items="schools"
                    item-value="id"
                    item-text="name"
                    :placeholder="$t('directive_admins.select_school')"
                    :rules="requiredRule('school')"
                  />
                </v-row>
              </v-col>
            </v-col>

          </v-row>

        </v-card>
      </v-col>

      <v-col cols="12" md="3" class="h-100">
        <v-row align="center" justify="center" class="h-100">
          <v-col cols="12" class="pb-0">
            <v-alert rounded outlined light color="deep-purple" class="pa-2 mb-0">
              <h4 class="text-left deep-purple--text lighten-2 font-weight-semibold">
                Acciones:
              </h4>
             <v-btn
                rounded
                small
                color="deep-purple lighten-1"
                dark
                @click.prevent="openChangePassword()"
              >
                 {{$t('directive_admins.create_new_information')}}
              </v-btn>
            </v-alert>
            </v-col>
        </v-row>
      </v-col>

      <!-- MODALS FOR THE PAGE -->
      <general-modal-container @onClose="closeChangePassword()" v-if="isChangePasswordModalOpen">
        <student-change-password-modal
          :student-name="adminInfo.name"
          :student-username="adminInfo.username"
          :student-id="adminInfo.id"
          :country-id="adminInfo.country_id"
          v-model="newPassword"
          :disabled-buttons="modalLoading"
          @onSave="onSavePassword()"
          @onCancel="closeChangePassword()"
        />
      </general-modal-container>

      <general-modal-container v-if="isImpersonateModalOpen" @onClose="closeImpersonateModal">
        <impersonate-app-selector-modal
          :user-name="impersonateUserLabel"
          @onSelect="handleImpersonateAppSelect"
          @onCancel="closeImpersonateModal"
        />
      </general-modal-container>
    </v-row>
  </v-form>
</template>

<script>
import GeneralModalContainer from '@/components/core/modals/GeneralModalContainer.vue';
import StudentChangePasswordModal from '@/components/students/StudentChangePasswordModal.vue';
import ImpersonateAppSelectorModal from '@/components/teachers/modals/ImpersonateAppSelectorModal.vue';

import LoadingMixin from '../../mixins/loading';
import SnackbarMixin from '../../mixins/snackbar';
import directiveAdminService from '../../services/directiveAdmin.service';
import userService from '../../services/user.service';
import impersonationService from '../../services/impersonation.service';
import {
  buildImpersonationLabel,
  buildImpersonationPayload,
  getImpersonationErrorMessage,
} from '../../utils/impersonation';

export default {
  name: 'DirectiveAdminEdit',
  props: { directiveAdminId: { type: [Number, String], default: 0 } },
  components: {
    GeneralModalContainer,
    StudentChangePasswordModal,
    ImpersonateAppSelectorModal,
  },
  data: () => ({
    valid: false,
    loading: false,
    modalLoading: false,
    isChangePasswordModalOpen: false,
    isImpersonateModalOpen: false,
    newPassword: '',
    created: null,
    lastAccessDate: null,
    schools: [],
    adminInfo: {},
    adminToSave: {
      dni: '',
      firstname: '',
      lastname: '',
      lastname2nd: '',
      email: '',
      birth_date: null,
      country_id: 1,
      active: true,
      school_id: null,
    },
  }),
  mixins: [LoadingMixin, SnackbarMixin],
  async mounted() {
    await this.loadDirectiveAdmin();
    await this.loadSchools();
  },
  methods: {
    async loadDirectiveAdmin() {
      this.loader();
      try {
        const adminId = parseInt(this.directiveAdminId, 10);
        const response = await directiveAdminService.getDirectiveAdmin(adminId);
        const admin = response.data.data || response.data;

        this.adminInfo = {
          id: admin.id,
          name: `${admin.firstname} ${admin.lastname}`,
          username: admin.username,
          country_id: admin.country_id || admin.country?.id || 1,
        };

        this.adminToSave = {
          dni: admin.dni || '',
          firstname: admin.firstname || '',
          lastname: admin.lastname || '',
          lastname2nd: admin.lastname2nd || '',
          email: admin.email || '',
          active: admin.active,
          school_id: admin.school_id ? parseInt(admin.school_id, 10) : null,
        };

        this.created = admin.creationDate;
        this.lastAccessDate = admin.lastAccessDate;
      } catch (error) {
        this.snackbarError('Error al cargar directivo');
      } finally {
        this.loader();
      }
    },

    async loadSchools() {
      try {
        const response = await directiveAdminService.getAvailableSchools();
        const schoolsData = response.data.data || response.data || [];
        this.schools = schoolsData.map((school) => ({
          id: parseInt(school.id, 10),
          name: school.name,
        }));
      } catch (error) {
        this.schools = [];
      }
    },

    async update() {
      if (this.$refs.form.validate()) {
        this.loader();
        try {
          const adminId = parseInt(this.directiveAdminId, 10);
          await directiveAdminService.updateDirectiveAdmin(
            adminId,
            this.adminToSave,
          );
          this.snackbarSuccess('Directivo actualizado exitosamente');
        } catch (error) {
          this.snackbarError('Error al actualizar directivo');
        } finally {
          this.loader();
        }
      }
    },

    openChangePassword() {
      this.isChangePasswordModalOpen = true;
    },
    closeChangePassword() {
      this.isChangePasswordModalOpen = false;
      this.newPassword = '';
    },
    openImpersonateModal() {
      const payload = buildImpersonationPayload({ ...this.adminToSave, id: this.adminInfo.id });
      if (!payload) {
        this.snackbarError(this.$t('students.action_error'));
        return;
      }
      this.isImpersonateModalOpen = true;
    },
    closeImpersonateModal() {
      this.isImpersonateModalOpen = false;
    },
    async handleImpersonateAppSelect(app) {
      this.closeImpersonateModal();
      const user = { ...this.adminToSave, id: this.adminInfo.id };
      const payload = buildImpersonationPayload(user);
      this.loader();
      try {
        if (app === 'teachers') {
          const response = await impersonationService.impersonate(payload);
          const redirectURL = response?.content?.redirectURL;
          if (!redirectURL) throw new Error(String(response?.content ?? this.$t('students.action_error')));
          window.open(redirectURL, '_blank');
        } else {
          const response = await impersonationService.impersonateForDataSystem(payload);
          if (!response?.redirectURL) throw new Error(this.$t('students.action_error'));
          window.open(response.redirectURL, '_blank');
        }
        this.snackbarSuccess(`${this.$t('students.impersonate_opening')} ${buildImpersonationLabel(user)}`.trim());
      } catch (error) {
        this.snackbarError(getImpersonationErrorMessage(error, this.$t('students.action_error')));
      } finally {
        this.loader();
      }
    },

    async onSavePassword() {
      this.modalLoading = true;
      try {
        const { dni } = this.adminToSave;
        if (!dni) {
          this.snackbarError('No se pudo identificar al directivo');
          return;
        }
        const response = await userService.changePassword({
          dni,
          country: this.adminInfo.country_id,
          password: this.newPassword,
        });
        if (response.status !== 200) {
          this.snackbarError('Error al cambiar contraseña');
        } else {
          this.snackbarSuccess('Contraseña actualizada exitosamente');
          this.closeChangePassword();
        }
      } catch (error) {
        this.snackbarError('Error al cambiar contraseña');
      } finally {
        this.modalLoading = false;
      }
    },

    requiredRule(field) {
      return [(v) => !!v || `${field} es requerido`];
    },
  },
  computed: {
    impersonateUserLabel() {
      return buildImpersonationLabel({ ...this.adminToSave, id: this.adminInfo.id });
    },
    dniRule() {
      return [
        (v) => !!v || 'DNI es requerido',
        (v) => v.length >= 8 || 'DNI debe tener al menos 8 caracteres',
      ];
    },

    emailRule() {
      return [
        (v) => !!v || 'Email es requerido',
        (v) => /.+@.+\..+/.test(v) || 'Email debe ser valido',
      ];
    },
  },
};
</script>

<style scoped>
.w-100 {
  width: 100%;
}
</style>
